import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import MenuItem from '../../menuItem'
import styles from '../../styles.scss'

const cx = classNames.bind(styles)

const BellNotification = ({ bellNotificationsCount, onClick }) => {
  return (
    <MenuItem onClick={onClick} className={cx('mobile-division')}>
      <div className={cx('bell-header')} data-elm-id='mb_bell_notifications'>
        {bellNotificationsCount !== '' && (
          <span
            className={cx('bell-notification')}
            onClick={onClick}
            data-elm-id='mobile_notification_count'
          >
            {bellNotificationsCount}
          </span>
        )}
        <span>Notifications</span>
      </div>
    </MenuItem>
  )
}

BellNotification.propTypes = {
  onClick: PropTypes.func,
  bellNotificationsCount: PropTypes.string,
}

export default BellNotification
